import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { ChevronRightIcon } from '../../theme/Icons';
import { BRAND } from './agencyChartTheme';

const useStyles = createUseStyles({
    chip: {
        flexShrink: 0,
        padding: '5px 11px',
        borderRadius: 14,
        border: `1px solid ${BRAND.tealEdge}`,
        background: 'var(--ion-background-color)',
        fontFamily: 'inherit',
        fontSize: 12.5,
        fontWeight: 600,
        color: 'var(--ion-color-primary)',
        whiteSpace: 'nowrap' as const,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5
    },

    button: {
        cursor: 'pointer',

        '&:hover, &:focus-visible': {
            borderColor: BRAND.deepTeal
        }
    }
});

/**
 * The pill that asks Bea about what is on screen. Given `onClick` it is a button of its own; without
 * one it is the label of a larger button around it, which cannot hold another.
 */
export const BeaAskChip: FC<{
    label: string;
    dataId: string;
    onClick?: () => void;
}> = ({ label, dataId, onClick }) => {
    const classes = useStyles();
    const content = (
        <>
            {label}
            <ChevronRightIcon color="primary" customSize={11} />
        </>
    );

    if (onClick) {
        return (
            <button type="button" className={`${classes.chip} ${classes.button}`} data-id={dataId} onClick={onClick}>
                {content}
            </button>
        );
    }

    return (
        <span className={classes.chip} data-id={dataId}>
            {content}
        </span>
    );
};
